export const varFont = {
  primary: 'Montserrat',
  secondary: 'Inter',
  tertiary: 'Nunito Sans',
  quaternary: 'Plus Jakarta Sans',
  quinary: 'Satoshi',
};

export const varTypography = {
  fontSize: {
    '10': '10px',
    '11': '11px',
    '12': '12px',
    '13': '13px',
    '14': '14px',
    '16': '16px',
    '18': '18px',
    '24': '24px',
    '28': '28px',
    '30': '30px',
    '36': '36px',
  },
  fontWeight: {
    '400': '400',
    '500': '500',
    '600': '600',
    '700': '700',
    '800': '800',
  },
};

export const varColor = {
  primary: '#2D80FC',
  secondary: '#C7ECFF',
  disabled: '#D1D5DB',
  info: '#2B5CE6',
  error: '#A73837',
  white: '#FFFFFF',
  black: '#000000',

  // Status
  statusOnline: '#4CAF50',
  statusOffline: '#AAB2A6',

  // Text
  colorPrimary: '#132429',
  colorDisabled: '#D1D5DB',
  colorLabelInput: '#374151',
  colorBlack: '#000000',
  colorSubTitle: '#111827',
  textPrimary: '#132429',
  textSecondary: '#6B7280',
  textRequired: '#B42318',
  textRose: '#991B1B',
  textOrange: '#92400E',
  textBlack: '#000000',
  textWhite: '#FFFFFF',
  textPlaceholder: '#949CA9',
  textPlaceholderPrimary: '#999999',
  textTitleAuth: '#282828',
  textTotalStatistic: '#202224',
  textPercentStatistic: '#12163C',
  textDescStatistic: '#606060',
  textTab: '#2D80FC',
  textDescription: '#8C8E90',
  textValue: '#4B5558',
  textTotal: '#2A2A2A',
  textGoogleRating: '#868686',
  textSelectOption: '#313144',
  textAdd: '#059669',
  textGreen: '#065F46',
  textDelete: '#FF3B30',
  textNumber: '#475569',
  textTitleCard: '#1E293B',
  textLabelSchedule: '#64748B',
  textOverbooking: '#F86B38',
  textSubTitleError: '#FECDCA',
  textTotalCost: '#22C55E',
  textPercent: '#0369A1',

  // Border, Divider
  border: '#D1D5DB',
  divider: '#E5E7EB',
  borderSecondary: '#DFE1E6',
  borderTextArea: '#ECECEE',

  // Background
  bgPrimary: '#FFFFFF',
  bgSecondary: '#F7F6F9',
  bgSidebar: '#C7ECFF',
  bgIcon: '#D9D9D9',
  bgNotification: '#EF4444',
  bgContent: '#F8FAFC',
  bgTotal: '#3B82F6',
  bgNumber: '#F1F5F9',
  bgHover: 'rgb(199 236 255 / 0.3)',
  bgBreakDown: '#FAFAFA',
  bgItemDashBoard: '#F9F9FD',
  bgPurple: '#9333EA',

  // Statistic
  bgStatisticRevenue: '#D0FAE0',
  bgStatisticCommission: '#FEE2E1',
  bgStatisticQuoteRequest: '#FEEFB4',
  bgStatisticActionItems: '#C7ECFF',
  bgStatisticNotFinalized: '#D9D8FF',
  bgStatisticSent: '#FEA500',
  bgStatisticConverted: '#77B900',
  bgStatisticTotalTask: '#E3EDFD',
  bgImage: '#F3F4F6',
  bgTable: '#EAECF0',
  bgAction: '#F9FAFB',
  bgItem: '#FAFAFA',

  // Status
  bgStatusBackgroundDefault: '#ECFDF5',
  bgStatusBackgroundError: '#FEF3F2',
  bgStatusBackgroundSecondary: '#FDF4FF',
  bgStatusBackgroundWarning: '#FEA5001A',
  bgStatusBackgroundPending: '#FFEDD5',
  bgStatusBackgroundInfo: '#EFF6FF',
  bgStatusBackgroundPrimary: '#6B72801A',
  bgStatusBackgroundSuccess: '#77B9001A',
  textStatusDefault: '#059669',
  textStatusError: '#B42318',
  textStatusSecondary: '#C11574',
  textStatusWarning: '#FEA500',
  textStatusPending: '#AB5435',
  textStatusInfo: '#2D80FC',
  textStatusPrimary: '#6B7280',
  textStatusSuccess: '#77B900',

  // Tag
  bgTagDefault: '#15803D33',
  bgTagError: '#C2410C14',
  textTagDefault: '#16A34A',
  textTagError: '#DC2626',

  // Message
  messageUnreadBg: '#305FEE',

  // Table
  bgTableHeader: '#DAE9FF',
  bgTableValid: '#F0FDF4',
  bgTableInValid: '#FEF2F2',
  borderTable: '#EAECF0',
  borderTableValid: '#86EFAC',
  borderTableInValid: '#FCA5A5',
  textTableValid: '#16A34A',
  textTableInValid: '#DC2626',

  // Select
  bgSelectContained: '#D9D9D9',

  // ScheduleKanban
  bgScheduleKanbanHeader: '#475569',
  borderScheduleKanban: '#E2E8F0',
  borderScheduleKanbanHeader: '#64748B',

  // Reports
  bgIconReportInventoryUsage: '#D0FAE0',
  bgIconReportOverbookingItems: '#D9D8FF',
  bgIconReportSubrentals: '#FFF4E6',
  bgIconReportQuarantine: '#FFE4E1',
  bgIconReportClientIncome: '#F0F9FF',
  bgIconReportRevenue: '#C7ECFF',
  bgIconReportGeographyRevenue: '#E8F5E8',
  bgIconReportQuoteRevenue: '#FDF2F8',
  bgIconReportOrderRevenue: '#FEEFB4',
};
